import { useEffect, useState } from "react";
import "./whatsapp-connection-notice.css";

// WHY [BOL-WA-STATUS-TRUTH-821]: DISCONNECTED has no ever-connected receipt.
// Never say "lost connection" or confuse UNAVAILABLE with confirmed offline.
// Pending only retains an already-visible attention path; it grants no auth
// or transport truth. CONNECTED removes all attention immediately.
export function whatsAppAttention(status: string | null, pending = false): string | null {
  switch (status) {
    case "DISCONNECTED": return "WhatsApp is not connected";
    case "SCAN_REQUIRED": return "Scan to connect WhatsApp";
    case "UNAVAILABLE": return "WhatsApp status is unavailable";
    case "STARTING": case "CONNECTING": case "RECONNECTING":
      return pending ? "WhatsApp is connecting" : null;
    default: return null;
  }
}

// WHY [BOL-WA-UNKNOWN-NOT-RECONNECT-001]: a control-read timeout becomes
// UNAVAILABLE, not evidence that paired WhatsApp disconnected. The red Connect
// popup is actionable only for a confirmed disconnected/scan-required state.
// Keep unknown/connecting status in the existing persistent navigation marker;
// never turn it into an auth-reset suggestion or preserve unsafe send readiness.
export function whatsAppReconnectActionable(status: string | null): boolean {
  return status === "DISCONNECTED" || status === "SCAN_REQUIRED";
}

export function WhatsAppAttentionMark() {
  return <i className="wa-attention-mark" aria-hidden="true">!</i>;
}

export function WhatsAppConnectionNotice({ message, status, visible, openWhatsApp }: {
  message: string | null;
  status: string | null;
  visible: boolean;
  openWhatsApp: () => void;
}) {
  const [dismissed, setDismissed] = useState(false);
  useEffect(() => { setDismissed(false); }, [status]);
  // Dismissal changes presentation only. The persistent noncolor More →
  // WhatsApp marker remains until current connection truth clears it.
  if (!message || !visible || dismissed || !whatsAppReconnectActionable(status)) return null;
  return <aside className="wa-connection-notice" aria-label="WhatsApp connection notice">
    {/* WHY [BOL-WA-SIMPLE-CONNECT-823]: the human wants one visible red action,
        not navigation instructions. Retain truthful status for assistive tech;
        the callback only opens the existing Ops connection screen. */}
    <div className="wa-connection-notice__status" role="status" aria-live="polite" aria-atomic="true">{message}</div>
    <button className="wa-connection-notice__open" type="button" onClick={openWhatsApp}>Connect WhatsApp</button>
    <button className="wa-connection-notice__dismiss" type="button" onClick={() => setDismissed(true)} aria-label="Dismiss WhatsApp notice">×</button>
  </aside>;
}
